















import { Prop, Component, Vue } from "vue-property-decorator";
import { AppConstants as _app } from "@/shared/app.constants";

@Component
export default class AmendmentRequestComponent extends Vue {
    @Prop() GrantInfo: any;
    @Prop() ReasonForAmendment: any;
    @Prop() readOnly: boolean;
    @Prop() model: any;
    @Prop() actionType: any;
    @Prop({ default: false }) hideAmendmentTypeSelection: boolean;

    amendmentTypes: Array<any> = _app.amendmentTypes.filter(x => x.group === this.actionType);

    mounted() {
    }

    submit() {
    }
}
